import { RxArrowRight } from 'react-icons/rx';
import { GiBackwardTime } from 'react-icons/gi';
import { format } from 'date-fns';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/common/Avataar';
import { Badge } from '@components/common/Badge';
import PropTypes from 'prop-types';
import { CardSkeleton } from '@components/loaders/SkeletonLoaders';

export function CandidateCard({ candidate, onOpenResume, loading, error }) {
    const getStatusVariant = status => {
        const variants = {
            Rejected: 'danger',
            Accepted: 'success',
            Review: 'default',
            default: 'warning',
        };
        return variants[status] || variants.default;
    };

    {
        loading && <CardSkeleton />;
    }
    {
        error && <div className="text-red-500 text-center col-span-3">Error: {error}</div>;
    }

    return (
        <div className="bg-white rounded-lg p-4 space-y-4">
            <div className="flex items-center justify-start gap-2">
                <Avatar>
                    <AvatarImage src={'//'} />
                    <AvatarFallback>{(candidate?.candidate_name || '').charAt(0)}</AvatarFallback>
                </Avatar>
                <div className="flex flex-col items-start">
                    <div className="text-sm font-semibold mb-[2px]">
                        {candidate?.candidate_name || ''}
                    </div>
                    <div className="text-xs text-gray-500">{candidate.job_title}</div>
                </div>
            </div>
            <div className="flex flex-wrap gap-1">
                <Badge
                    variant={getStatusVariant(candidate.interview_status)}
                    className="rounded-full"
                >
                    {candidate.interview_status}
                </Badge>
            </div>
            {candidate?.lastUpdated && (
                <div className="text-gray-600 flex items-center">
                    <span className="text-primary-blue mr-1 text-sm">
                        <GiBackwardTime />
                    </span>
                    Last Updated:
                    <span className="text-black">
                        {format(new Date(candidate?.lastUpdated), 'MMM, d, yyyy')}
                    </span>
                </div>
            )}
            {candidate?.cv_link && (
                <div
                    className="text-primary-blue font-bold text-sm flex items-center cursor-pointer"
                    onClick={() => onOpenResume(candidate.cv_link)}
                >
                    Open Resume
                    <RxArrowRight className="w-4 h-4 ml-2" />
                </div>
            )}
        </div>
    );
}

CandidateCard.propTypes = {
    candidate: PropTypes.object.isRequired,
    onOpenResume: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    error: PropTypes.string,
};
